'use client'

import type { CtaButtonProps } from '@components/app/WhitePaper/CtaButton'
import { CtaButtonServerSide } from '@components/app/WhitePaper/CtaButton'
import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import type { StringDictionary } from '@lib/types/dictionary'
import pick from 'lodash/pick'
import { useSearchParams } from 'next/navigation'

const PASS_ALONG_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'referral_url',
]

export function CtaButtonClientSide(props: CtaButtonProps) {
  const query = Object.fromEntries(useSearchParams()?.entries() ?? [])
  const urlParams = pick(query, PASS_ALONG_PARAMS)
  const url = urlWithQueryParams(
    props.url,
    urlParams as StringDictionary,
  ).toString()

  return <CtaButtonServerSide {...props} url={url} />
}
